const NewsIcon = ({ className }: { className?: string }) => (
	<svg
		class={className}
		fill='currentColor'
		height='24'
		viewBox='0 0 16 14'
		width='24'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M13 7.75V6.25H16V7.75H13ZM13.8542 13.5L11.3958 11.7917L12.2708 10.5625L14.7292 12.2708L13.8542 13.5ZM12.25 3.4375L11.3958 2.20833L13.8542 0.5L14.7083 1.72917L12.25 3.4375ZM2 13V9H1.5C1.0875 9 0.734375 8.85313 0.440625 8.55938C0.146875 8.26563 0 7.9125 0 7.5V6.5C0 6.0875 0.146875 5.73438 0.440625 5.44063C0.734375 5.14688 1.0875 5 1.5 5H4.39583L9 2.25V11.75L4.52083 9H4V13H2ZM7.5 9.0625V4.89583L4.8125 6.5H1.5V7.5H4.95833L7.5 9.0625ZM10 9.4375V4.5625C10.3194 4.86806 10.566 5.23611 10.7396 5.66667C10.9132 6.09722 11 6.54167 11 7C11 7.45833 10.9132 7.90278 10.7396 8.33333C10.566 8.76389 10.3194 9.13194 10 9.4375Z'
			fill='currentColor'
		/>
	</svg>
)

export { NewsIcon }
